import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError, tap } from 'rxjs';
import { ApplicationInsightsService } from '../_services/application-insights.service';

@Injectable()
export class ErrorCatchingInterceptor implements HttpInterceptor {
  constructor(private appInsights: ApplicationInsightsService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (
      request.url.includes('hereapi.com') ||
      request.url.includes('here.com') ||
      request.url.includes('maps.api.here.com')
    ) {
      return next.handle(request);
    }
    const startTime = Date.now();

    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        // Track successful HTTP requests
        if (event.type === 4) {
          // HttpEventType.Response
          const duration = Date.now() - startTime;
          this.appInsights.trackApiCall(
            `${request.method} ${request.url}`,
            duration,
            true,
            event['status']?.toString()
          );
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const duration = Date.now() - startTime;
        let errorMsg = '';

        if (error.error instanceof ErrorEvent) {
          console.log('This is client side error');
          errorMsg = `Error: ${error.error.message}`;

          // Track client-side error
          const clientError = new Error(
            error.error.message || 'Unknown client error'
          );
          this.appInsights.trackException(clientError, {
            url: request.url,
            method: request.method,
            type: 'client-side',
          });
        } else {
          console.log('This is server side error');
          errorMsg = `${error.error.error}`;

          // Track server-side error
          this.appInsights.trackException(
            new Error(`HTTP Error ${error.status}: ${errorMsg}`),
            {
              url: request.url,
              method: request.method,
              status: error.status.toString(),
              type: 'server-side',
              responseBody: JSON.stringify(error.error),
            }
          );
        }

        console.log(
          `Error Code: ${error.status}, Message: ${error.error.error}`
        );

        // Track failed HTTP request
        this.appInsights.trackApiCall(
          `${request.method} ${request.url}`,
          duration,
          false,
          error.status.toString()
        );

        return throwError(() => error);
      })
    );
  }
}
